export default function (
  deepLinkUrl: string,
  fallbackUrl: string,
  timeoutDuration = 1500
) {
  return new Promise((resolve, reject) => {
    // Set a timeout to fallback to the app store if the deep link fails
    const timeout = setTimeout(() => {
      // Fallback to the app store if the app is not installed
      window.location.href = fallbackUrl;
      //   reject(new Error("app_not_installed"));
    }, timeoutDuration);

    // Try to open the app using the deep link
    window.location.href = deepLinkUrl;

    // Resolve if the app opens successfully (we assume it worked if the user stays on the deep link)
    const blurHandler = () => {
      clearTimeout(timeout);
      resolve("");
    };

    // Listen for blur event (indicating the app was opened)
    window.addEventListener("blur", blurHandler);
    window.addEventListener("pagehide", blurHandler);
    document.addEventListener("visibilitychange", blurHandler);
    // Clean up the event listener if the user navigates away
    return () => {
      clearTimeout(timeout);
      window.removeEventListener("blur", blurHandler);
      //   window.removeEventListener("pagehide", blurHandler);
      //   document.removeEventListener("visibilitychange", blurHandler);
    };
  });
}
